module.exports = __webpack_public_path__ + "img/hr-train-wheels-3.886e8e96.png";